document.addEventListener('DOMContentLoaded', function() {
  const wishListButton = document.querySelector('.wishlist-button');
  let iconWishlist = null;
  let iconWishlistAdd = null;
  if (window.globalData) {
    iconWishlist = window.globalData.wishlistIconId;
    iconWishlistAdd = window.globalData.wishlistIconAddId;
  }
  if (wishListButton) {
    const productId = wishListButton.dataset.productId;
    let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
    let count = wishlist.length;  

    function updateButtonState(isInWishlist, userInteraction = false) {
      count = wishlist.length; 
      const popupNotification = document.querySelector('.wishlist-popup');
      if (isInWishlist) {
        wishListButton.classList.add('added-to-wishlist');
        fetch(iconWishlistAdd)
          .then(response => response.text())
          .then(svg => {
            wishListButton.innerHTML = svg;
          })
          .catch(err => {
            console.error("Error loading SVG: ", err);
            wishListButton.textContent = "Error loading icon";
          });
      } else {
        wishListButton.classList.remove('added-to-wishlist');
        fetch(iconWishlist)
          .then(response => response.text())
          .then(svg => {
            wishListButton.innerHTML = svg;
          })
          .catch(err => {
            console.error("Error loading SVG: ", err);
            wishListButton.textContent = "Error loading icon";
          });
      }
  }

    const isInWishlist = wishlist.includes(productId);
    updateButtonState(isInWishlist, false);

    wishListButton.addEventListener('click', function () {
      const index = wishlist.indexOf(productId);
      if (index === -1) {
        wishlist.push(productId);
      } else {
        wishlist.splice(index, 1);
      }
      localStorage.setItem('wishlist', JSON.stringify(wishlist));
      updateButtonState(index === -1, true);
    });
  }
});